if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function getAccommodations(container, selectVal) {
    fetch(`${site_url}ajax/functions.php?operation=getSiteAcommodations&tag=` + selectVal, { method: "GET" })
        .then((resp) => resp.json()) // Transform the data into json
        .then((data) => {
            container.innerHTML = data.html; //set data response via fetch in the container
            $('.list__images').slick({
                accessibility: true,
                fade: true
            });
        });
}

self.fetch || (self.fetch = function (e, n) { return n = n || {}, new Promise(function (t, s) { var r = new XMLHttpRequest, o = [], u = [], i = {}, a = function () { return { ok: 2 == (r.status / 100 | 0), statusText: r.statusText, status: r.status, url: r.responseURL, text: function () { return Promise.resolve(r.responseText) }, json: function () { return Promise.resolve(JSON.parse(r.responseText)) }, blob: function () { return Promise.resolve(new Blob([r.response])) }, clone: a, headers: { keys: function () { return o }, entries: function () { return u }, get: function (e) { return i[e.toLowerCase()] }, has: function (e) { return e.toLowerCase() in i } } } }; for (var c in r.open(n.method || "get", e, !0), r.onload = function () { r.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function (e, n, t) { o.push(n = n.toLowerCase()), u.push([n, t]), i[n] = i[n] ? i[n] + "," + t : t }), t(a()) }, r.onerror = s, r.withCredentials = "include" == n.credentials, n.headers) r.setRequestHeader(c, n.headers[c]); r.send(n.body || null) }) });


(function () {

    $(document).ready(function () {
        $('.sym-slides').slick({
            accessibility: true
        });
    });

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */
    const rooms_container = document.getElementById('js-accommodations-content');
    const roomsNav = document.querySelectorAll('.accommodations__nav a');
    if (rooms_container) {
        for (let i = 0; i < roomsNav.length; i++) {
            roomsNav[i].addEventListener('click', function () {
                const thisTag = this.dataset.tag;
                // console.log(thisTag);
                getAccommodations(rooms_container, thisTag);
                for (let m = 0; m < roomsNav.length; m++) {
                    roomsNav[m].classList.remove('active');
                }
                this.classList.add('active');
            });
        }
        getAccommodations(rooms_container, '');
    }

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
    paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    //vanilla JS fancybox
	if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open')
			});
		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open')
			});
		}
	}

    //for Menus
	document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu__unitmenu').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});

})();

$('.fancybox').fancybox();
